import React, { Component } from 'react';
import ApplicationFlowRouter from './routers';

class App extends Component {
    render() {
        return (
            <ApplicationFlowRouter />
        );
    }
}

export default App;
